import React, { useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import BusinessInterest from './BusinessInterest';
import InstallerPortal from './InstallerPortal';
import WorkerEnrollment from '../components/installer/WorkerEnrollment';

// Use one registration path at a time. A failed email-status check enables the
// manual fallback; retry loading keeps that draft until email access is confirmed.
// A verified session stays in memory during the portal handoff.
export default function ProAccess() {
  const { lang } = useLang();
  const [verifiedSession, setVerifiedSession] = useState('');
  const [showApplication, setShowApplication] = useState(false);
  const availabilityChanged = status => {
    if (status === 'available') setShowApplication(false);
    else if (status !== 'loading') setShowApplication(true);
  };
  if (verifiedSession) return <InstallerPortal initialSession={verifiedSession} />;
  return <BusinessInterest kind="professional" showApplication={showApplication}>
    <WorkerEnrollment lang={lang} onAvailabilityChange={availabilityChanged} onAuthenticated={({ session_token }) => setVerifiedSession(session_token)} />
  </BusinessInterest>;
}
